import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BarChart } from 'lucide-react';
const metrics = ['Medición clara de resultados', 'Optimización basada en datos', 'Reducción de costo por adquisición', 'Generación de leads calificados', 'Enfoque en retorno sobre inversión'];
export function Performance() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-128">
          <motion.div className="flex-1" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-129">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium mb-6" data-id="element-130">
              <BarChart className="w-4 h-4 mr-2" data-id="element-131" />
              Resultados Medibles
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-132">
              Enfoque en Performance
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-133">
              Cada decisión se basa en datos. Cada optimización busca mejorar
              tus números. Dejamos de lado las suposiciones para trabajar con
              métricas reales que impactan tu negocio.
            </p>

            <ul className="space-y-4" data-id="element-134">
              {metrics.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.4
            }} className="flex items-center text-slate-700" data-id="element-135">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0" data-id="element-136" />
                  <span className="font-medium" data-id="element-137">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-138">
            <div className="relative" data-id="element-139">
              {/* Decorative elements */}
              <div className="absolute -top-10 -right-10 w-64 h-64 bg-slate-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" data-id="element-140"></div>
              <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" data-id="element-141"></div>

              <div className="relative bg-slate-900 rounded-2xl p-8 shadow-2xl text-white" data-id="element-142">
                <div className="flex justify-between items-end mb-8" data-id="element-143">
                  <div data-id="element-144">
                    <p className="text-slate-400 text-sm mb-1" data-id="element-145">
                      Costo por Lead (CPL)
                    </p>
                    <h3 className="text-4xl font-bold text-white" data-id="element-146">$4.50</h3>
                  </div>
                  <div className="text-green-400 text-sm font-medium bg-green-400/10 px-2 py-1 rounded" data-id="element-147">
                    -32% vs mes anterior
                  </div>
                </div>

                {/* Simple Chart Visualization */}
                <div className="h-48 flex items-end justify-between gap-2" data-id="element-148">
                  {[40, 65, 45, 80, 55, 90, 75].map((height, i) => <div key={i} className="w-full bg-slate-800 rounded-t-sm relative group" data-id="element-149">
                      <motion.div className="absolute bottom-0 left-0 right-0 bg-blue-600 rounded-t-sm" initial={{
                    height: 0
                  }} whileInView={{
                    height: `${height}%`
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.5 + i * 0.1,
                    duration: 1,
                    ease: 'easeOut'
                  }} data-id="element-150" />
                    </div>)}
                </div>

                <div className="flex justify-between mt-4 text-xs text-slate-500" data-id="element-151">
                  <span data-id="element-152">Semana 1</span>
                  <span data-id="element-153">Semana 4</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}